import { renderRoutes } from 'react-router-config'
import { matchPath } from 'react-router'
import React, { useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { FacebookProvider } from 'react-facebook'
import emmit from '@/pages/sea/utils/emitter'
import { get } from '@/pages/sea/utils/fetch'
import { authToken } from '@/utils/helper'
import { isPC } from '@/utils'
import {
  useStoreReducer,
  StoreContext,
  storeActionType,
} from '@/pages/sea/context'

// 无需PC和m跳转的白名单
const WHITE_LIST = [
  '/match-result',
  '/doram-kingdom-reserve',
  '/doram-kingdom-reserve-fb',
  '/ten-people-race',
  '/tenPeopleRace',
  '/activity/anniversary/:vroleid',
  '/For-Honor-reserve',
  '/reservation/sakura2024',
]

/**
 * BaseLayout
 */
const BaseLayout = (props: React.PropsWithChildren<any>) => {
  const { route, children } = props
  const [store, dispatch] = useStoreReducer()
  const { t } = useTranslation()

  const storeCtxValue = useMemo(() => ({ store, dispatch }), [dispatch, store])

  const { refetch: getJobIntro } = useQuery<
    unknown,
    ReturnData | Error,
    ReturnData
  >('/sea/api/job-intro', async () => get('/api/job-intro'), {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (res) => {
      dispatch({
        type: storeActionType.UPDATE_HOMEDATA,
        data: res?.data,
      })
    },
  })

  const getData = (res: any) => [
    {
      id: 0,
      name: t('sea.recent'),
      weight: 0,
    },
    ...((res?.data?.news_categories as any[]) ?? []),
  ]

  const { refetch: getNewsCategories } = useQuery<
    unknown,
    ReturnData | Error,
    ReturnData
  >('/sea/api/news-categories', async () => get('/api/news-categories'), {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (res) => {
      dispatch({
        type: storeActionType.UPDATE_NEWS_CATEGORIES,
        data: getData(res),
      })
    },
  })

  useEffect(() => {
    emmit.on('getJobIntro', () => {
      getJobIntro()
    })
    return () => {
      emmit.off('getJobIntro', () => {
        getJobIntro()
      })
    }
  }, [getJobIntro])

  useEffect(() => {
    emmit.on('getNewsCategories', () => {
      getNewsCategories()
    })
    return () => {
      emmit.off('getNewsCategories', () => {
        getNewsCategories()
      })
    }
  }, [getNewsCategories])

  useEffect(() => {
    if (authToken()) {
      dispatch({
        type: storeActionType.LOGIN_STATUS,
        data: true,
      })
    }
  }, [dispatch])

  useEffect(() => {
    const { pathname, search } = window.location
    if (!WHITE_LIST.some((routeStr) => matchPath(pathname, routeStr))) {
      const path = pathname.slice(1).split('/') || []
      if (isPC()) {
        if (path[0] === 'm') {
          window.location.replace(`/${path.slice(1).join('/')}${search}`)
        }
      } else if (path[0] !== 'm') {
        window.location.replace(`/m${pathname}${search}`)
      }
    }
  }, [])

  const lang = localStorage.getItem('i18nextLng') || 'en'
  return (
    <div className="layout-container">
      <FacebookProvider appId="820791479705055" language={lang}>
        <StoreContext.Provider value={storeCtxValue}>
          {renderRoutes(route.routes)}
          {children}
        </StoreContext.Provider>
      </FacebookProvider>
    </div>
  )
}

export default React.memo(BaseLayout)
